import { gql } from '@apollo/client';
import { TRUCK_FIELDS } from '../../fragments';
import { CreateTruckProps } from './truck.types';
import { TruckType } from '../../../types';

export const CREATE_TRUCK = gql`
${TRUCK_FIELDS}
mutation createTruck(
  $transporterName: String!,
  $truckRegistrationNumber: String!,
  $tonnage: String,
){
  createTruck(
    transporterName: $transporterName,
    truckRegistrationNumber: $truckRegistrationNumber,
    tonnage: $tonnage,
  ){
    ...TruckFields
  }
}
`;

export function createTruck({
  client,
  transporterName,
  truckRegistrationNumber,
  tonnage,
}: CreateTruckProps) {
  return client?.mutate<{ createTruck: TruckType }>({
    mutation: CREATE_TRUCK,
    variables: {
      transporterName,
      truckRegistrationNumber,
      tonnage,
    },
  });
}
